import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ClothTypeDef } from '@api/types/ClothTypeDef';
import { CustomerOrderDef } from '@api/types/CustomerOrderDef';
import { CatCustomerOrderDef } from '@api/types/CatCustomerOrderDef';
import { PartnerOrderDef } from '@api/types/PartnerOrderDef';
import { PartnerRequestDef } from '@api/types/PartnerRequestDef';
import { PaymentTypeDef } from '@api/types/PaymentTypeDef';
import { DeliveryTypeDef } from '@api/types/DeliveryTypeDef';
import { CatProbeOrderDef } from '@api/types/CatProbeOrderDef';
import { AnimalTypeEnum } from '@api/types/AnimalTypeEnum';



export const baseApi = createApi({
	reducerPath: 'baseApi',
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.DATA_API_URL}/`,
	}),
	tagTypes: [
		'price',
		'clothTypes',
		'paymentTypes',
		'deliveryTypes',
		'catProbePrice',
	],
	endpoints: (builder) => ({
		
		getPrice: builder.query<number, { size: number, animalType: AnimalTypeEnum, paymentType?: number, deliveryType?: number }>({
			query: ({ size, animalType, paymentType, deliveryType }) => ({
				url: 'Pricing/GetPrice',
				params: { size, animalType, paymentType, deliveryType }
			}),
			providesTags: ['price'],
		}),

		getCatProbePrice: builder.query<number, { neckCircumference: number }>({
			query: ({ neckCircumference }) => ({
				url: 'Pricing/GetPrice',
				params: { neckCircumference }
			}),
			providesTags: ['catProbePrice'],
		}),

		getClothTypes: builder.query<ClothTypeDef[], { animalType: AnimalTypeEnum }>({
			query: ({ animalType }) => ({
				url: 'ClothType/GetClothTypes',
				params: { animalType }
			}),
			providesTags: ['clothTypes'],
		}),

		getPaymentTypes: builder.query<PaymentTypeDef[], void>({
			query: () => ({
				url: 'DeliveryType/GetPaymentTypes',
			}),
			providesTags: ['paymentTypes'],
		}),

		getDeliveryTypes: builder.query<DeliveryTypeDef[], void>({
			query: () => ({
				url: 'DeliveryType/GetDeliveryTypes',
			}),
			providesTags: ['deliveryTypes'],
		}),


		saveCustomerOrder: builder.mutation<number, CustomerOrderDef>({
			query: (customerOrder) => ({
				url: 'CustomerOrder/Save',
				method: 'POST',
				body: customerOrder
			}),
		}),

		saveCatCustomerOrder: builder.mutation<number, CatCustomerOrderDef>({
			query: (catCustomerOrder) => ({
				url: 'CatCustomerOrder/Save',
				method: 'POST',
				body: catCustomerOrder
			}),
		}),

		savePartnerOrder: builder.mutation<void, PartnerOrderDef>({
			query: (partnerOrder) => ({
				url: 'PartnerOrder/Save',
				method: 'POST',
				body: partnerOrder
			}),
		}),

		savePartnerRequest: builder.mutation<void, PartnerRequestDef>({
			query: (partnerRequest) => ({
				url: 'PartnerRequest/Save',
				method: 'POST',
				body: partnerRequest
			}),
		}),

		saveCatProbeRequest: builder.mutation<void, CatProbeOrderDef>({
			query: (catProbeRequest) => ({
				url: 'CatProbeRequest/Save',
				method: 'POST',
				body: catProbeRequest
			}),
		}),
	}),
});



export const {
	useLazyGetPriceQuery,
	useLazyGetCatProbePriceQuery,
	useGetClothTypesQuery,
	useGetPaymentTypesQuery,
	useGetDeliveryTypesQuery,
	useSaveCustomerOrderMutation,
	useSaveCatCustomerOrderMutation,
	useSavePartnerOrderMutation,
	useSavePartnerRequestMutation,
	useSaveCatProbeRequestMutation } = baseApi;